import type { AppMarketingAppLinks } from './app-marketing-app-links';

const ALLOWED_LINK_SCHEMES = new Set(['https:', 'http:', 'tel:', 'mailto:']);

export const isSafeAppMarketingHref = (url: string): boolean => {
    const trimmed = url.trim();

    if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
        return true;
    }

    try {
        return ALLOWED_LINK_SCHEMES.has(new URL(trimmed).protocol);
    } catch {
        return false;
    }
};

export const isAllowedAppMarketingDownloadUrl = (url: string, appLinks?: AppMarketingAppLinks): boolean => {
    try {
        if (new URL(url).protocol !== 'https:') {
            return false;
        }
    } catch {
        return false;
    }

    if (!appLinks) {
        return true;
    }

    return Object.values(appLinks).some((configuredLink) => configuredLink === url);
};
